import React from 'react';
export function PainSection() {
  const pains = ['Domingo a la noche buscando ejercicios que nunca quedan como querés', 'Clases improvisadas porque no tenés actividades listas y secuenciadas para ese curso', 'Alumnos que no hacen nada porque el material es aburrido y no tiene contexto', 'Horas perdidas en Google buscando problemas de cinemática, estequiometría o reacciones químicas', 'Planificaciones que armás de apuro y que igual te devuelve el directivo con correcciones', 'La ESI y la EAI obligatorias del PEI sin saber cómo articularlas con Física o Química'];
  const scrollToPricing = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Note: This mid-page CTA still scrolls to pricing so users can choose between the 2 options.
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-163">
      <div className="max-w-[680px] mx-auto" data-id="element-164">
        <div className="text-sci-orange text-xs uppercase tracking-wide text-center mb-4 font-semibold" data-id="element-165">
          SI SOS DOCENTE DE CIENCIAS NATURALES,
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-carbon text-center mb-10" data-id="element-166">
          esto te va a sonar familiar:
        </h2>

        <div className="space-y-6 mb-10" data-id="element-167">
          {pains.map((pain, i) => <div key={i} className="flex gap-3 items-start" data-id="element-168">
              <span className="text-xl flex-shrink-0" data-id="element-169">❌</span>
              <p className="text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-170">
                {pain}
              </p>
            </div>)}
        </div>

        <p className="text-lg md:text-xl font-bold text-gray-700 text-center mb-8" data-id="element-171">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Extra persuasive CTA */}
        <button onClick={scrollToPricing} className="w-full max-w-md mx-auto block bg-sci-orange hover:bg-orange-600 text-white font-bold text-base md:text-lg py-4 px-6 rounded-lg transition-colors shadow-lg" data-id="element-172">
          → DEJÁ DE PERDER DOMINGOS — VER PRECIOS
        </button>
      </div>
    </section>;
}